module.exports = __webpack_public_path__ + "img/entry.b1cac071.png";